import { FC, useEffect, useState } from "react";
import ScreenBase from "./ScreenBase";
import { Stack, Typography } from "@mui/material";
import useGetCollection from "../hooks/getCollection";
import BlogPost from "../models/blogPost";
import ScreenBanner from "../components/screenBanner";
import digitalFuture from "../assets/digital-future.jpg";
import BlogTile from "../components/blogTile";

const BlogScreen: FC = () => {
	const { data: blogData, loading } = useGetCollection<BlogPost[]>('/blogPost/published');

	const [blogs, setBlogs] = useState<BlogPost[]>([]);

	useEffect(() => {
		setBlogs(blogData || []);
	}, [blogData]);
	
	return (
		<ScreenBase
			fixedChildren={(
				<Stack spacing={2}>
					<ScreenBanner
						title="Tim Kulig Free Music Blog"
						bannerImage={digitalFuture}
						height={120}
						verticalAdjust="50%"
						brightnessAdjust={0.75}
					/>
				</Stack>
			)}
			scrollableChildren={(
				<Stack spacing={4} minHeight="calc(100vh - 525px)">
					<Stack spacing={2} px={4} maxWidth="70ch">
						<Typography variant="body2" color="textPrimary">
							Welcome to the TKFM Blog! Updates on my free music library, how I write tunes,
							my equipment, news, announcements, and more! Updated every Friday.
						</Typography>
					</Stack>
					<Stack spacing={2}>
						{!loading && (
							<>
								{blogs.map((blog, index) => (
									<BlogTile key={`blog-${index}`} blogPost={blog} />
								))}
							</>
						)}
						{loading && (
							<>
							</>
						)}
					</Stack>
				</Stack>
			)}
		/>
	);
};

export default BlogScreen;
